// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.app-progress {
  font-size: 14px;
}
.app-progress__section {
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  color: #b2b2b2;
  line-height: 2;
  margin-bottom: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
  transition: background-color 0.5s ease, color 0.5s ease;
}
.app-progress__status-indicator {
  width: 20%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.app-progress__status-label {
  width: 80%;
  padding-left: 4px;
}
.app-progress__check {
  display: none;
  filter: invert(28%) sepia(100%) saturate(6926%) hue-rotate(219deg) brightness(106%) contrast(105%);
}
.app-progress__circle {
  background-color: transparent;
  border: 2px solid #b2b2b2;
  border-radius: 50%;
  height: 18px;
  width: 18px;
}
.app-progress__section.\\--active, .app-progress__section.\\--complete {
  color: #fff;
}
.app-progress__section.\\--active {
  background-color: #263758;
}
.app-progress__section.\\--active .app-progress__check {
  display: none;
}
.app-progress__section.\\--active .app-progress__circle {
  background-color: #d6e4ff;
  border: 3px solid #0157ff;
  display: block;
}
.app-progress__section.\\--complete .app-progress__check {
  display: block;
}
.app-progress__section.\\--complete .app-progress__circle {
  display: none;
}
.app-progress__section.\\--complete:hover {
  background-color: #0157ff;
  color: #fff;
  cursor: pointer;
}
.app-progress__section.\\--visited .app-progress__circle {
  background-color: #d6e4ff;
  border-color: #0157ff;
}
.app-progress__section.\\--visited:hover {
  background-color: #0157ff;
  color: #fff;
  cursor: pointer;
}
.app-progress__section.\\--visited:hover .app-progress__circle {
  border-color: #b2b2b2;
}
.app-progress.\\--finished .app-progress__section.\\--complete:hover {
  background-color: transparent;
  cursor: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/bankrate/app-progress.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uDAAuD;AACzD;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kGAAkG;AACpG;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.app-progress {\n  font-size: 14px;\n}\n.app-progress__section {\n  display: flex;\n  flex-direction: row;\n  border-radius: 4px;\n  color: #b2b2b2;\n  line-height: 2;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  padding-top: 8px;\n  transition: background-color 0.5s ease, color 0.5s ease;\n}\n.app-progress__status-indicator {\n  width: 20%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.app-progress__status-label {\n  width: 80%;\n  padding-left: 4px;\n}\n.app-progress__check {\n  display: none;\n  filter: invert(28%) sepia(100%) saturate(6926%) hue-rotate(219deg) brightness(106%) contrast(105%);\n}\n.app-progress__circle {\n  background-color: transparent;\n  border: 2px solid #b2b2b2;\n  border-radius: 50%;\n  height: 18px;\n  width: 18px;\n}\n.app-progress__section.\\--active, .app-progress__section.\\--complete {\n  color: #fff;\n}\n.app-progress__section.\\--active {\n  background-color: #263758;\n}\n.app-progress__section.\\--active .app-progress__check {\n  display: none;\n}\n.app-progress__section.\\--active .app-progress__circle {\n  background-color: #d6e4ff;\n  border: 3px solid #0157ff;\n  display: block;\n}\n.app-progress__section.\\--complete .app-progress__check {\n  display: block;\n}\n.app-progress__section.\\--complete .app-progress__circle {\n  display: none;\n}\n.app-progress__section.\\--complete:hover {\n  background-color: #0157ff;\n  color: #fff;\n  cursor: pointer;\n}\n.app-progress__section.\\--visited .app-progress__circle {\n  background-color: #d6e4ff;\n  border-color: #0157ff;\n}\n.app-progress__section.\\--visited:hover {\n  background-color: #0157ff;\n  color: #fff;\n  cursor: pointer;\n}\n.app-progress__section.\\--visited:hover .app-progress__circle {\n  border-color: #b2b2b2;\n}\n.app-progress.\\--finished .app-progress__section.\\--complete:hover {\n  background-color: transparent;\n  cursor: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
